import React from 'react';
const ToolButton = ({ onClickEvent, children, label, disabled }) => {
    return (React.createElement("button", { className: "th-c-tools__button", onClick: onClickEvent, disabled: disabled },
        children,
        React.createElement("span", null, label)));
};
export default ToolButton;
